import { getRoles } from "@/services/config";
import KeycloakService from "@/services/keycloak/keycloakService";
import router from "..";

export function guardAuth(to: any, from: any, next: any){
    const hasUser = localStorage.getItem('userInfo');
    const hasToken = localStorage.getItem('token');
    const isMeta = "auth" in to.meta;
    const metaAuth = to.meta.auth;

    if(isMeta && metaAuth && !hasToken && !hasUser){
        KeycloakService.CallLogin();
    } else if(isMeta && !metaAuth && hasUser){
        roleType(JSON.parse(hasUser), next);
    } else {
        if(hasToken){
            KeycloakService.RefreshToken();
        }
        
        next();
    }
}

function roleType(user: any, next: any): void{
    if(getRoles().includes('ADMIN_IOSI')){
        next('/organizations');
    } else if(getRoles().includes('ADMIN')){
        next('/users');
    } else if(getRoles().includes('USER')){
      next("/agendamento");
    } else if (getRoles().includes('CLIENT')){
        next("/agendamento");
    } else {
        next("/")
    }
  }